<template>
    <div id="series-content">
        <div class="series-content_list" v-for="(item, i) in noveloutline" :key="i">
            <el-input v-model="item.title" :readonly="readonly" class="series-content-title"
                @input="handler(noveloutline)" placeholder="请输入标题" show-word-limit maxlength="50"></el-input>
            <el-input v-model="item.content" :readonly="readonly" class="series-content-content"
                @input="handler(noveloutline)" type="textarea" placeholder="请输入内容" show-word-limit maxlength="2000"
                autosize></el-input>

            <!-- 删除 -->
            <!-- <div class="editor_del_btn cursor_1" title="删除" v-if="isEdit && editType === 3 && !item.id"
                @click="del(item, i)"><i class="el-icon-delete"></i></div>
            <div class="editor_edit_btn cursor_1" title="修改" v-if="isEdit && editType === 3" @click="edit(item, i)"><i
                    class="el-icon-edit"></i></div> -->
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus';

export default {
    props: {
        noveloutline: {
            type: Array,
            default: []
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        editType: {
            type: String | Number,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            outlineNum: 0, // 字数
            handText: '',
        }
    },
    mounted() {

    },
    watch: {
        noveloutline: {
            deep: true,
            handler: 'handler'
        }
    },
    created() {
        this.handler(this.noveloutline);
    },
    methods: {
        handler(newVal) {
            this.outlineNum = newVal.reduce((total, item) => {
                return total + item.title.length + item.content.length;
            }, 0);
            this.$emit('getoutlineNum', {
                num: this.outlineNum,
                list: this.noveloutline
            });
            sessionStorage.setItem('ifeditStatus', true);
        },
        del(item, i) {
            console.log('删除=', item, ' i=', i)
            this.$emit('del', { index: i, id: item.id || -1, item })
        },
        edit(item, i) {
            console.log('编辑=', item, ' i=', i)
            this.$emit('edit', { index: i, id: item.id || -1, item })
        }
    }
};
</script>
<style lang="scss" scoped>
#series-content {
    position: relative;
}

.series-content_list {
    position: relative;

    ::v-deep(.el-input__inner) {
        border: 0;
    }

    ::v-deep(.el-textarea__inner) {
        border: 0;
    }
}

.series-content-title {
    ::v-deep(.el-input__count-inner) {
        background-color: transparent !important;
    }

    ::v-deep(.el-input__inner) {
        font-weight: bold !important;
        font-size: 17px !important;
        color: #111 !important;

        // &:hover {
        //     background-color: var(--tech-primary) !important;
        //     cursor: text;
        // }
        // &:focus{
        //     background-color: #fff !important;
        // }
    }
}

.series-content-content {
    ::v-deep(.el-input__count) {
        background-color: transparent !important;
    }

    ::v-deep(.el-textarea__inner) {
        font-size: 16px !important;
        color: #111 !important;
        padding: 0 15px 25px;
        resize: none !important;
        // &:hover {
        //     background-color: var(--tech-primary) !important;
        //     cursor: text;
        // }
        // &:focus{
        //     background-color: #fff !important;
        // }
    }

    @include scrollbar();

    &:hover {
        @include scrollbar_hover();
    }
}

.editor_del_btn {
    position: absolute;
    right: 10px;
    top: 8px;
    color: var(--tech-primary);
}

.editor_edit_btn {
    position: absolute;
    right: -15px;
    top: 8px;
    color: var(--tech-primary);
}
</style>